import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { AuthService, Alert, ConfigService } from '../../services';
import ButtonLoader from '../../components/ButtonLoader';
import { React, useState } from 'react';
import AuthHeaderTextComponent from '../../components/auth/AuthHeaderTextComponent';
import FormInput from '../../components/FormInput';

const ForgotPassword = () => {
  const [isLoader, setLoader] = useState(false);

  const schema = Yup.object({
    email: Yup.string().required('Email is required').email('Email is invalid'),
  }).required();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (_input) => {
    try {
      setLoader(true);
      const forgotPasswordData = {
        email: _input.email,
      };

      let response = await AuthService.forgotPassword(forgotPasswordData);
      if (response.status === 'failure') {
        setLoader(false);
        Alert.error(response.message);
        return false;
      }

      setLoader(false);
      reset();
      Alert.success(response.message);
    } catch (error) {
      setLoader(false);
      Alert.error(error.message);
      return false;
    }
  };

  return (
    <div className="hasBGSignUp">
      <div className="flex items-center justify-center min-h-screen">
        <div className="w-full md:w-96 bg-white px-6 py-10 rounded-md m-6">
          <AuthHeaderTextComponent
            title={'Forget Password'}
            desc={`To reset your password, enter the email address you use to sign in to ${ConfigService.appName()}.`}
          />
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-6">
              <FormInput
                label="Email Address"
                name="email"
                type="email"
                placeholder="Email Address"
                register={register}
                errors={errors}
              />
            </div>

            <div className="">
              <button
                type="submit"
                disabled={isLoader}
                className="bg-[#A7D760] text-[#0B243F] text-lg font-semibold rounded-md px-5 leading-normal py-3 flex flex-col justify-center items-center hover:bg-[#97C05B] focus:bg-[#A7D760] active:bg-[#8DB158] hover:transition-all w-full"
              >
                {isLoader ? (
                  <ButtonLoader title={'Processing'} />
                ) : (
                  'Send Reset Link'
                )}
              </button>
            </div>
          </form>
          <Link to={isLoader ? '#' : '/login'}>
            <div
              className={`my-3 text-[#3D4CB2] text-center ${isLoader ? 'text-gray-400 pointer-events-none' : ''}`}
            >
              Login
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
